module.exports = __webpack_public_path__ + "static/media/Vehicle.svg";